import { baseApiService } from "../../../shared/services/api/axios-config/axios-config";
import { errosHandler } from "../../../shared/services/errors/erros-handler";
import { CriarClienteFormData } from "../schema/criar-empresa.schema";
import { EditarClienteFormData } from "../schema/editar-empresa.schema";


const criar = async (data: CriarClienteFormData): Promise<void> => {
    try {
        await baseApiService.post('/client', data);
    } catch (err) {
        throw errosHandler(err);
    }
};

const deletar = async (id: string): Promise<string> => {
    try {
        const response = await baseApiService.delete(`/client/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const detalhar = async (id: string): Promise<any> => {
    try {
        const response = await baseApiService.get(`/client/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const editar = async (id: string, data: EditarClienteFormData): Promise<void> => {
    try {
        await baseApiService.put(`/client/${id}`, data);
    }
    catch (err) {
        throw errosHandler(err);
    }
};

const findAll = async (filtro?: string, pagina = 0, limite = 10): Promise<{ items: any[]; totalItems: number }> => {
    try {
        const campoPesquisa = "fantasy_name,full_name";
        const query = filtro?.trim()
            ? `/client?page=${pagina + 1}&limit=${limite}&campo_pesquisa=${campoPesquisa}&tipo_pesquisa=in&valor_pesquisa=${filtro}`
            : `/client?page=${pagina + 1}&limit=${limite}`;
        const result = await baseApiService.get(query);
        const responseData = result.data?.data;
        return {
            items: Array.isArray(responseData?.items) ? responseData.items : [],
            totalItems: responseData?.meta?.totalItems || 0,
        };
    } catch (error) {
        console.error("Erro ao buscar cliente:", error);
        throw errosHandler(error);
    }
};

const selectCliente = async (): Promise<any> => {
    try {
        const response = await baseApiService.get(`/client/select?onlyActive=true`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const buscarClientes = async (termo: string): Promise<{ id: string; label: string }[]> => {
    try {
        if (!termo || termo.trim().length < 2) {
            return [];
        }

        const response = await baseApiService.get(
            `/client?campo_pesquisa=fullName&valor_pesquisa=${encodeURIComponent(termo)}&page=1&limit=20`
        );

        const items = response.data?.data?.items || [];
        return items.map((cliente: any) => ({
            id: cliente.id,
            label: cliente.corporateName || cliente.fullName || cliente.fantasyName || "",
        }));
    } catch (err) {
        console.error("Erro ao buscar clientes:", err);
        throw errosHandler(err);
    }
};

export const clienteService = {
    criar,
    deletar,
    detalhar,
    editar,
    findAll,
    selectCliente,
    buscarClientes,
};

